import { render, staticRenderFns } from "./IangerEcharts.vue?vue&type=template&id=5054e9a8&scoped=true&"
import script from "./IangerEcharts.vue?vue&type=script&lang=js&"
export * from "./IangerEcharts.vue?vue&type=script&lang=js&"
import style0 from "./IangerEcharts.vue?vue&type=style&index=0&id=5054e9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054e9a8",
  null
  
)

export default component.exports